module.exports = __webpack_public_path__ + "5b71e551dbadaa24aed90bd2e01521e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/neu/junger-mann-alleinerziehende-frau-neu.svg
// module id = 137
// module chunks = 1